import { Group, TextInput, Select } from '@mantine/core';
import { IconSearch, IconArrowsSort } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export interface SortOpt { value: string; label: string }

/**
 * Jadval ustidagi umumiy panel: server qidiruv + filtrlar (children) + saralash.
 * Barcha admin sahifalarida yagona uslub.
 */
export function TableToolbar({
  search, onSearch, searchPlaceholder,
  sort, onSort, sortOptions,
  children,
}: {
  search: string;
  onSearch: (v: string) => void;
  searchPlaceholder?: string;
  sort?: string;
  onSort?: (v: string) => void;
  sortOptions?: SortOpt[];
  children?: React.ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <Group mb="md" gap="sm" align="flex-end" wrap="wrap">
      <TextInput
        placeholder={searchPlaceholder ?? t('common.search')}
        leftSection={<IconSearch size={16} />}
        value={search}
        onChange={(e) => onSearch(e.currentTarget.value)}
        w={260}
      />
      {children}
      {sortOptions && onSort ? (
        <Select
          leftSection={<IconArrowsSort size={16} />}
          data={sortOptions}
          value={sort}
          onChange={(v) => v && onSort(v)}
          allowDeselect={false}
          w={210}
        />
      ) : null}
    </Group>
  );
}
